import { render, staticRenderFns } from "./ManualAcknowledgementNotice.vue?vue&type=template&id=1ca5e36b&scoped=true"
import script from "./ManualAcknowledgementNotice.vue?vue&type=script&lang=js"
export * from "./ManualAcknowledgementNotice.vue?vue&type=script&lang=js"
import style0 from "./ManualAcknowledgementNotice.vue?vue&type=style&index=0&id=1ca5e36b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca5e36b",
  null
  
)

export default component.exports